export const linkTarget = {
  NEW_BROWSER_TAB: process.env.NODE_ENV === 'test' ? '_self' : '_blank',
};
